export default __webpack_public_path__ + "static/media/emptyInvoice.e605226d.svg";